import {PushNotificationsState} from '../../enums/push-notifications-state';
import {AuthContextState, AuthContextAction, AuthContextActionType} from './types';

const reducer = (prevState: AuthContextState, action: AuthContextAction): AuthContextState => {
  switch (action.type) {
    case AuthContextActionType.RESTORE_SESSION:
      return {
        ...prevState,
        isRestoringSession: false,
        firebaseUser: action.firebaseUser,
        session: action.session,
      };
    case AuthContextActionType.SIGN_IN:
      return {
        ...prevState,
        firebaseUser: action.firebaseUser,
        session: action.session,
      };
    case AuthContextActionType.SIGN_OUT:
      return {
        ...prevState,
        isRestoringSession: false,
        firebaseUser: undefined,
        session: undefined,
        pushNotificationsState: PushNotificationsState.Unknown,
      };
    case AuthContextActionType.UPDATE_SESSION:
      return {
        ...prevState,
        session: action.session,
      };
    case AuthContextActionType.SET_PUSH_NOTIFICATIONS_STATE:
      return {
        ...prevState,
        pushNotificationsState: action.pushNotificationsState,
      };
  }
};
export default reducer;
